import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "home" }
      }
    ]
  }
];

export const asyncRouterMap = [
  {
    path: "/admin",
    component: Layout,
    redirect: "/admin/admin",
    name: "sysadmin",
    meta: { title: "企业管理员", icon: "ums-admin" },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/admin/index"),
        meta: { title: "管理员列表", icon: "product-list" }
      },
      {
        path: "adminAdd",
        name: "adminAdd",
        component: () => import("@/views/admin/add"),
        meta: { title: "新增管理员", icon: "product-list" },
        hidden: true
      },
      {
        path: "adminEdit",
        name: "adminEdit",
        component: () => import("@/views/admin/edit"),
        meta: { title: "编辑管理员", icon: "product-list" },
        hidden: true
      },
      {
        path: "adminWatch",
        name: "adminWatch",
        component: () => import("@/views/admin/watch"),
        meta: { title: "查看新增管理员", icon: "product-list" },
        hidden: true
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/role/index"),
        meta: { title: "角色列表", icon: "role" }
      }
    ]
  },
  {
    path: "/shop",
    component: Layout,
    redirect: "/shop/shop",
    name: "sysShop",
    meta: { title: "企业店铺", icon: "sysShop" },
    children: [
      {
        path: "shop",
        name: "shop",
        component: () => import("@/views/shop/shop/index"),
        meta: { title: "店铺", icon: "sms-new" }
      },
      {
        path: "shopAdd",
        name: "shopAdd",
        component: () => import("@/views/shop/shop/add"),
        meta: { title: "新增店铺", icon: "product-list" },
        hidden: true
      },
      {
        path: "shopUpdate",
        name: "shopUpdate",
        component: () => import("@/views/shop/shop/update"),
        meta: { title: "编辑店铺", icon: "product-list" },
        hidden: true
      },
      {
        path: "staff",
        name: "user",
        component: () => import("@/views/shop/staff/index"),
        meta: { title: "员工", icon: "staff" }
      },
      {
        path: "staffAdd",
        name: "staffAdd",
        component: () => import("@/views/shop/staff/add"),
        meta: { title: "新增员工", icon: "product-list" },
        hidden: true
      },
      {
        path: "staffUpdate",
        name: "staffUpdate",
        component: () => import("@/views/shop/staff/update"),
        meta: { title: "编辑员工", icon: "product-list" },
        hidden: true
      }
    ]
  },
  // {
  //   path: "/store",
  //   component: Layout,
  //   redirect: "/store/store",
  //   children: [
  //     {
  //       path: "store",
  //       name: "warehouse",
  //       component: () => import("@/views/store/index"),
  //       meta: { title: "仓库管理", icon: "store" }
  //     },
  //     {
  //       path: "storeAdd",
  //       name: "warehouseAdd",
  //       component: () => import("@/views/store/add"),
  //       meta: { title: "新增仓库", icon: "ums-role" },
  //       hidden: true
  //     },
  //     {
  //       path: "storeUpdate",
  //       name: "warehouseUpdate",
  //       component: () => import("@/views/store/edit"),
  //       meta: { title: "编辑仓库", icon: "ums-role" },
  //       hidden: true
  //     },
  //   ]
  // },
  {
    path: "/stock",
    component: Layout,
    redirect: "/stock/check",
    children: [
      {
        path: "check",
        name: "stockCheck",
        component: () => import("@/views/stock/check/index"),
        meta: { title: "库存预警商品", icon: "store" }
      },
      {
        path: "checkAdd",
        name: "checkAdd",
        component: () => import("@/views/stock/check/add"),
        meta: { title: "新增", icon: "ums-role" },
        hidden: true
      },
      {
        path: "checkUpdate",
        name: "checkUpdate",
        component: () => import("@/views/stock/check/edit"),
        meta: { title: "编辑", icon: "ums-role" },
        hidden: true
      },
    ]
  },
  {
    path: "/inventory",
    component: Layout,
    redirect: "/inventory/stockInventory",
    children: [
      {
        path: "inventory",
        name: "stockCheckInventory",
        component: () => import("@/views/stock/inventory/index"),
        meta: { title: "库存预警盘点", icon: "log" }
      },
    ]
  },
  {
    path: "/purchase",
    component: Layout,
    redirect: "/purchase/category",
    children: [
      {
        path: "category",
        name: "purchaseItemCategory",
        component: () => import("@/views/purchase/category/index"),
        meta: { title: "采购物品分类", icon: "purchase" }
      },
    ]
  },
  {
    path: "/buy",
    component: Layout,
    redirect: "/purchase/item",
    children: [
      {
        path: "item",
        name: "purchaseItem",
        component: () => import("@/views/purchase/item/index"),
        meta: { title: "采购物品列表", icon: "buy" }
      },
      {
        path: "itemAdd",
        name: "itemAdd",
        component: () => import("@/views/purchase/item/add"),
        meta: { title: "新增", icon: "ums-role" },
        hidden: true
      },
      {
        path: "itemUpdate",
        name: "itemUpdate",
        component: () => import("@/views/purchase/item/edit"),
        meta: { title: "编辑", icon: "ums-role" },
        hidden: true
      },
    ]
  },
  {
    path: "/category",
    component: Layout,
    redirect: "/category/category",
    name: "petRelate",
    meta: { title: "宠物相关", icon: "product-brand" },
    children: [
      {
        path: "category",
        name: "category",
        component: () => import("@/views/pet/category/index"),
        meta: { title: "宠物分类", icon: "category" }
      },
      {
        path: "categoryAdd",
        name: "categoryAdd",
        component: () => import("@/views/pet/category/add"),
        meta: { title: "新增宠物分类", icon: "ums-role" },
        hidden: true
      },
      {
        path: "categoryUpdate",
        name: "categoryUpdate",
        component: () => import("@/views/pet/category/update"),
        meta: { title: "编辑宠物分类", icon: "ums-role" },
        hidden: true
      },
      {
        path: "categoryHistory",
        name: "categoryHistory",
        component: () => import("@/views/pet/category/history"),
        meta: { title: "同步平台分类", icon: "ums-role" },
        hidden: true
      },
      {
        path: "pet",
        name: "pet",
        component: () => import("@/views/pet/pet/index"),
        meta: { title: "宠物", icon: "pet" }
      },
      {
        path: "petAdd",
        name: "petAdd",
        component: () => import("@/views/pet/pet/add"),
        meta: { title: "新增宠物", icon: "ums-role" },
        hidden: true
      },
      {
        path: "petUpdate",
        name: "petUpdate",
        component: () => import("@/views/pet/pet/update"),
        meta: { title: "查看宠物", icon: "ums-role" },
        hidden: true
      },
      {
        path: "dorm",
        name: "dormitory",
        component: () => import("@/views/pet/dorm/index"),
        meta: { title: "宿舍", icon: "dorm" }
      },
      {
        path: "dormAdd",
        name: "dormAdd",
        component: () => import("@/views/pet/dorm/add"),
        meta: { title: "新增宿舍", icon: "ums-role" },
        hidden: true
      },
      {
        path: "dormUpdate",
        name: "dormUpdate",
        component: () => import("@/views/pet/dorm/update"),
        meta: { title: "编辑宿舍", icon: "ums-role" },
        hidden: true
      },
      {
        path: "dormWatch",
        name: "dormWatch",
        component: () => import("@/views/pet/dorm/history"),
        meta: { title: "查看宿舍", icon: "ums-role" },
        hidden: true
      }
    ]
  },
  {
    path: "/medical",
    component: Layout,
    redirect: "/medical/commondisease",
    name: "medical",
    meta: { title: "医疗相关", icon: "order" },
    children: [
      {
        path: "commondisease",
        name: "commondisease",
        component: () => import("@/views/medical/commondisease/index"),
        meta: { title: "常见病症", icon: "commondisease" }
      },
      {
        path: "commondiseaseAdd",
        name: "commondiseaseAdd",
        component: () => import("@/views/medical/commondisease/add"),
        meta: { title: "新增常见病症", icon: "product-list" },
        hidden: true
      },
      {
        path: "commondiseaseUpdate",
        name: "commondiseaseUpdate",
        component: () => import("@/views/medical/commondisease/update"),
        meta: { title: "编辑常见病症", icon: "ums-role" },
        hidden: true
      },
      {
        path: "commondiseaseHistory",
        name: "commondiseaseHistory",
        component: () => import("@/views/medical/commondisease/history"),
        meta: { title: "同步平台分类", icon: "product-list" },
        hidden: true
      },
      {
        path: "expellinginsects",
        name: "expellinginsects",
        component: () => import("@/views/medical/expellinginsects/index"),
        meta: { title: "宠物驱虫", icon: "expellinginsects" }
      },
      {
        path: "expellinginsectsAdd",
        name: "expellinginsectsAdd",
        component: () => import("@/views/medical/expellinginsects/add"),
        meta: { title: "新增宠物驱虫", icon: "ums-role" },
        hidden: true
      },
      {
        path: "expellinginsectsUpdate",
        name: "expellinginsectsUpdate",
        component: () => import("@/views/medical/expellinginsects/update"),
        meta: { title: "编辑宠物驱虫", icon: "ums-role" },
        hidden: true
      },
      {
        path: "expellinginsectsHistory",
        name: "expellinginsectsHistory",
        component: () => import("@/views/medical/expellinginsects/history"),
        meta: { title: "同步平台分类", icon: "product-list" },
        hidden: true
      },
      {
        path: "vaccine",
        name: "vaccine",
        component: () => import("@/views/medical/vaccine/index"),
        meta: { title: "宠物疫苗", icon: "vaccine" }
      },
      {
        path: "vaccineAdd",
        name: "vaccineAdd",
        component: () => import("@/views/medical/vaccine/add"),
        meta: { title: "新增宠物疫苗", icon: "ums-role" },
        hidden: true
      },
      {
        path: "vaccineUpdate",
        name: "vaccineUpdate",
        component: () => import("@/views/medical/vaccine/update"),
        meta: { title: "编辑宠物疫苗", icon: "ums-role" },
        hidden: true
      },
      {
        path: "vaccineHistory",
        name: "vaccineHistory",
        component: () => import("@/views/medical/vaccine/history"),
        meta: { title: "同步平台分类", icon: "ums-role" },
        hidden: true
      }
    ]
  },
  {
    path: "/log",
    component: Layout,
    redirect: "/log/log",
    children: [
      {
        path: "log",
        name: "workLog",
        component: () => import("@/views/log/index"),
        meta: { title: "工作日志", icon: "log" }
      },
    ]
  },
  {
    path: "/shopCheck",
    component: Layout,
    redirect: "/shopCheck/record",
    name: "shopCheck",
    meta: { title: "巡店管理", icon: "sysShop" },
    children: [
      {
        path: "paramConfig",
        name: "shopCheckParamConfig",
        component: () => import("@/views/shopCheck/config/index"),
        meta: { title: "巡店参数配置", icon: "sms-new" }
      },
      {
        path: "paramConfigAdd",
        name: "shopCheckParamAdd",
        component: () => import("@/views/shopCheck/config/add"),
        meta: { title: "新增巡店参数配置", icon: "product-list" },
        hidden: true
      },
      {
        path: "paramConfigUpdate",
        name: "shopCheckParamEdit",
        component: () => import("@/views/shopCheck/config/update"),
        meta: { title: "编辑巡店参数配置", icon: "product-list" },
        hidden: true
      },
      {
        path: "record",
        name: "shopCheck",
        component: () => import("@/views/shopCheck/record/index"),
        meta: { title: "巡店记录", icon: "staff" }
      },
      {
        path: "recordHistory",
        name: "shopCheck",
        component: () => import("@/views/shopCheck/record/history"),
        meta: { title: "巡店记录详情", icon: "staff" },
        hidden: true
      },
    ]
  },
  {
    path: "/system",
    component: Layout,
    redirect: "/system/daily",
    name: "systemconfig",
    meta: { title: "系统设置", icon: "systen-set" },
    children: [
      {
        path: "daily",
        name: "getDailyCheckWarn",
        component: () => import("@/views/system/daily"),
        meta: { title: "日常未做提醒", icon: "daily-warn" }
      },
      {
        path: "stage",
        name: "getStageCheckWarn",
        component: () => import("@/views/system/stage"),
        meta: { title: "阶段未做提醒", icon: "stage-warn" },
      },
      {
        path: "expellinginsects",
        name: "expellingInsectsWarn",
        component: () => import("@/views/system/expellinginsects"),
        meta: { title: "驱虫提醒", icon: "ill-warn" },
      },
      // {
      //   path: "ill",
      //   name: "getDiseaseWarn",
      //   component: () => import("@/views/system/ill"),
      //   meta: { title: "疾病提醒", icon: "ill-warn" },
      // },
      {
        path: "store",
        name: "getWarehouseWarn",
        component: () => import("@/views/system/store"),
        meta: { title: "库存提醒", icon: "store-warn" },
      },
      {
        path: "dorm",
        name: "getDormitoryWarn",
        component: () => import("@/views/system/dorm"),
        meta: { title: "宿舍提醒", icon: "dorm-warn" }
      },
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js